import { ExternalLink } from "lucide-react";

export const CFG_VIDEO_URL = "https://www.facebook.com/reel/1804242200722339/";

export default function VideoCard() {
  const src = `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(CFG_VIDEO_URL)}&show_text=false&width=360`;

  return (
    <div data-testid="cfg-video-card" className="relative max-w-md mx-auto w-full">
      <div className="absolute -inset-4 sm:-inset-6 rounded-2xl bg-volt/10 blur-2xl animate-pulse-glow pointer-events-none" aria-hidden="true" />
      <div className="relative rounded-lg border border-volt/25 bg-pine overflow-hidden shadow-[0_40px_80px_-20px_rgba(0,0,0,0.6)]">
        <span className="absolute top-3 left-3 z-10 h-5 w-5 border-t-2 border-l-2 border-volt/70" aria-hidden="true" />
        <span className="absolute top-3 right-3 z-10 h-5 w-5 border-t-2 border-r-2 border-volt/70" aria-hidden="true" />
        <div className="aspect-video w-full bg-obsidian">
          <iframe
            src={src}
            title="BNM Carbon Free Generator in operation — official video"
            className="w-full h-full border-0"
            scrolling="no"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            allowFullScreen
            loading="lazy"
          />
        </div>
      </div>
      <div className="mt-4 flex items-center justify-between gap-4">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-volt/80">
          Official Video — In Operation
        </p>
        <a
          href={CFG_VIDEO_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cfg-video-facebook-link"
          className="inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.16em] text-slate-500 hover:text-volt transition-colors"
        >
          Facebook
          <ExternalLink className="h-3 w-3" aria-hidden="true" />
        </a>
      </div>
    </div>
  );
}
